import { createAction, ActionType, createReducer } from 'typesafe-actions';

interface TutorialReducer {
  t1: number;
  t2: number;
  t3: number;
  t4: number;
  t5: number;
  status: number;
  [key: string]: number;
}

const initialState: TutorialReducer = {
  t1: 0,
  t2: 0,
  t3: 0,
  t4: 0,
  t5: 0,
  status: 0,
};

export const SET_TUTORIAL = 'TutorialReducer/setTutorial';

export const setTutorial = createAction(SET_TUTORIAL)<{ [key: string]: number }>();

export const actions = { setTutorial };
type TutorialReducerActions = ActionType<typeof actions>;

const TutorialReducer = createReducer<TutorialReducer, TutorialReducerActions>(initialState, {
  [SET_TUTORIAL]: (state, action) => {
    const cur_state = {
      ...state,
      ...action.payload,
      status: 1,
    };
    return cur_state;
  },
});

export default TutorialReducer;
